export enum MessageType {
    TOAST = 'tst',
    ALERT = 'msg'
  }
